import React, { Component } from 'react';


class Navbar extends Component {
    
    async componentDidMount(){
        
        const about = document.querySelector('#rounded');
        
        about.addEventListener('click', () => {
            window.location.href='https://www.instagram.com/rizki_4106/';
        });
        
        const kontak = document.querySelector('.kontak');
        
        kontak.addEventListener('click', () => {
            window.open("https://www.instagram.com/rizki_4106/");
        });
        
        const proxy = "https://cors-anywhere.herokuapp.com/";
        const source = "https://api.darksky.net/forecast/0abe209b3a80006bcb5210202298cd53/39.5158825,-116.8537227?lang=id";
        
        const res = await fetch(`${proxy}${source}`);
        const hasil = await res.json();
        
        console.log(hasil);
        
        
    }

    render(){
        return(
            <>
            <div className='navbar-atas'>
            
            
            <div className='container'>
            
            
            <div className='kolom-navbar'>
            
            <div id='kolom-brand'>
            <h4 id='logo'><b>Z</b>Wheather</h4>
            </div>
            
            <div id='kolom-tombol'>
            <button type="button" className="btn btn-light kontak">Kontak</button>
            <button type="button" className="btn btn-primary " id='rounded'>Tentang</button>
            
            </div>
            
            </div>
            
            
            </div>
            
            
            </div>
            </>
        )
    }
    
}

export default Navbar;